/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts from 'highcharts';
import { merge, cloneDeep } from 'lodash';
import { Box, Divider, Dialog, DialogActions, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { barChartBase } from './utils/barChartBase';

const scrollableMinHeight = averageByCountries => {
  if (averageByCountries.length >= 100) {
    return 4000;
  }
  return averageByCountries.length * 40;
};

const AverageDeliveryDaysDialog = ({
  averageDeliveryDays,
  open,
  handleClose
}) => {
  const override = {
    chart: {
      scrollablePlotArea: {
        minHeight: scrollableMinHeight(averageDeliveryDays.averageByCountries),
        opacity: 0.6
      },
      marginRight: 30
    },
    xAxis: {
      categories: averageDeliveryDays.averageByCountries.map(
        a => a.country.name
      ),
      pointPadding: 30
    },
    yAxis: {
      stackLabels: {
        enabled: false
      },
      maxPadding: 0.1
    },
    plotOptions: {
      series: {
        dataLabels: {
          inside: false,
          // eslint-disable-next-line
          formatter: function() {
            return `${this.total} jours`;
          }
        }
      }
    },
    series: [
      {
        name: 'Temps de livraison',
        data: averageDeliveryDays.averageByCountries
          .slice(0, 100)
          .map(a => [a.country.name, a.deliveryDays])
      }
    ]
  };
  const options = merge(cloneDeep(barChartBase), override);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Box pt={6} pl={10} pr={10}>
        <Box display="flex" alignItems="baseline" mb={4}>
          <Box fontSize={21} color="#001C56">
            Moyenne du temps de livraison par pays
          </Box>
        </Box>
      </Box>
      <HighchartsReact highcharts={Highcharts} options={options} />
      <Divider />
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  averageDeliveryDays: state.dashboard.averageDeliveryDays
});

AverageDeliveryDaysDialog.propTypes = {
  averageDeliveryDays: PropTypes.array,
  open: PropTypes.bool,
  handleClose: PropTypes.func
};

export default connect(mapStateToProps)(AverageDeliveryDaysDialog);
